import http from './http';

// 监控上报
const fetchBeginUploadDoorlock = (data) => {
  return http({
    method: 'POST',
    url: '/room/card/mark-room-card-begin',
    data,
  });
};

// 门锁上报结果
const fetchEndUploadDoorlock = (data) => {
  return http({
    method: 'POST',
    url: '/room/card/mark-room-card-end',
    data,
  });
};

// 获取hotelId
const fetchHotelId = () => {
  return http({
    url: '/lock/vendor/hotel/hotelId',
  });
};

// 更新hotelId
// const updateHotelId = (data) => {
//   return http({
//     url: `/lock/vendor/hotel/${data.hotelId}/create-update`,
//     method: 'POST',
//     data,
//   });
// };

// 根据房间id查询锁号
const fetchLockNoByRoomId = (data) => {
  return http({
    url: `/room/lock/no?roomId=${data.roomId}`,
    method: 'POST',
  });
};

// 获取房间列表
const fetchRoomList = (params) => {
  return http({
    url: '/room/card/rooms',
    params,
  });
};

// 获取房间信息
const fetchRoomInfo = (params) => {
  return http({
    url: `/room/card/${params.roomId}/msg`,
  });
};

// 获取房间所有房卡
const fetchRoomCardList = (data) => {
  return http({
    url: '/room/card/list',
    method: 'POST',
    data,
  });
};

// 获取房卡信息
const fetchCardInfo = (params) => {
  return http({
    url: `/room/card/detail`,
    params,
  });
};

// 制房卡
const crateRoomCard = (data) => {
  return http({
    url: '/room/card/create',
    method: 'POST',
    data,
  });
};

// 更新房卡
const updateRoomCard = (data) => {
  return http({
    url: '/room/card/',
    method: 'PUT',
    data,
  });
};

// 退房卡
const checkRoomCard = (data) => {
  return http({
    url: `/room/card/checkout`,
    method: 'PUT',
    data,
  });
};

// 获取剩余未退的卡数量
const fetchRestCards = (data) => {
  return http({
    url: '/room/card/remainder',
    method: 'POST',
    data,
  });
};

// 挂失房卡
const lossRoomCard = (data) => {
  return http({
    url: `/room/card/${data.id}/report-loss`,
    method: 'PUT',
  });
};

// 更新锁号
const updateRoomLockNo = (data) => {
  return http({
    url: '/room/lock/create-update',
    method: 'POST',
    data,
  });
};

// 获取门店是否启用房卡
const fetchCardEnable = () => {
  return http({
    url: '/lock/vendor/hotel/one',
  });
};

// 获取房卡供应商列表
const fetchVendorList = () => {
  return http({
    url: '/lock/vendor/hotel',
  });
};

// 启用/停用房卡
const enableRoomCard = (data) => {
  return http({
    url: '/lock/vendor/hotel/bind/unbind',
    method: 'POST',
    data,
  });
};

export {
  fetchBeginUploadDoorlock,
  fetchEndUploadDoorlock,
  fetchHotelId,
  // updateHotelId,
  fetchLockNoByRoomId,
  fetchRoomList,
  fetchRoomInfo,
  fetchRoomCardList,
  fetchCardInfo,
  crateRoomCard,
  updateRoomCard,
  checkRoomCard,
  fetchRestCards,
  lossRoomCard,
  updateRoomLockNo,
  fetchCardEnable,
  fetchVendorList,
  enableRoomCard,
};
